import { getWurfl } from "App/services/wurflService";

/**
 * Gets the DeviceTypeEnum for the RED MS
 */
const getRedemptionMSDevice = (): string => {
  const formFactor = getWurfl().form_factor;

  switch (formFactor) {
    case 'Tablet':
      return 'TABLET';
    case 'Smartphone':
      return 'SMARTPHONE';
    case 'Feature Phone':
      return 'FEATURE_PHONE';
    case 'Smart-TV':
      return 'SMART_TV';
    case 'Robot':
      return 'ROBOT';
    case 'Other non-Mobile':
      return 'OTHER_NON_MOBILE';
    case 'Other Mobile':
      return 'OTHER_MOBILE';
    case 'Desktop':
    default:
      return 'DESKTOP';
  }
};

export default getRedemptionMSDevice;